import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { AppState } from '../index';
import { PackageService } from '../../data/package.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import {
    packageEditorLoadComplete,
    packageEditorLoadFailure,
    packageEditorLoadRequest, packageEditorNew, packageEditorSaveFailure,
    packageEditorSaveRequest, packageEditorSaveSuccess
} from './package-editor.actions';
import { catchError, filter, map, switchMap, tap, withLatestFrom } from 'rxjs/operators';
import { selectPackageEditorState } from './package-editor.state';
import { of } from 'rxjs';
import { packageTableRequest } from '../package-table/package-table.actions';
import { PackageEditComponent } from 'src/app/modules/package-library/package-edit/package-edit.component';

@Injectable()
export class PackageEditorEffects {

    constructor(private actions$: Actions, private store: Store<AppState>, private packageService: PackageService,
                private snackbar: MatSnackBar, private dialog: MatDialog) {
    }

    packageEditorLoad$ = createEffect(() => this.actions$.pipe(
        ofType(packageEditorLoadRequest),
        switchMap((action) => this.packageService.getByKey(action.id).pipe(
            map((pkg) => packageEditorLoadComplete({ pkg })),
            catchError(() => of(packageEditorLoadFailure()))
        ))
    ));

    packageEditorLoadFailure$ = createEffect(() => this.actions$.pipe(
        ofType(packageEditorLoadFailure),
        tap(() => this.snackbar.open($localize`We are having difficulty communicating with the server.  Please try again later.`)),
        tap(() => this.dialog.closeAll())
    ), { dispatch: false });

    packageEditorUpdate$ = createEffect(() => this.actions$.pipe(
        ofType(packageEditorSaveRequest),
        withLatestFrom(this.store.select(selectPackageEditorState)),
        filter(([ , state ]) => state.id !== null),
        switchMap(([ , state ]) => this.packageService.update(state.package).pipe(
            map(() => packageEditorSaveSuccess()),
            catchError(() => of(packageEditorSaveFailure()))
        ))
    ));

    packageEditorCreate$ = createEffect(() => this.actions$.pipe(
        ofType(packageEditorSaveRequest),
        withLatestFrom(this.store.select(selectPackageEditorState)),
        filter(([ , state ]) => state.id === null),
        switchMap(([ , state ]) => this.packageService.add(state.package).pipe(
            map(() => packageEditorSaveSuccess()),
            catchError(() => of(packageEditorSaveFailure()))
        ))
    ));

    packageEditorSaveSuccess$ = createEffect(() => this.actions$.pipe(
        ofType(packageEditorSaveSuccess),
        tap(() => this.dialog.closeAll()),
        tap(() => this.snackbar.open($localize`Package Template saved successfully`)),
        map(() => packageTableRequest())
    ));

    packageEditorSaveFailure$ = createEffect(() => this.actions$.pipe(
        ofType(packageEditorSaveFailure),
        tap(() => this.snackbar.open($localize`Unable to save changes to this package template.  Please try again.`))
    ), { dispatch: false });

    packageEditorNew$ = createEffect(() => this.actions$.pipe(
        ofType(packageEditorNew),
        tap(() => this.dialog.open(PackageEditComponent))
    ), { dispatch: false });

}
